import { prefixClassName } from "@smartrr/shared/components/primitives";
import { AquariusCard } from "@smartrr/shared/customerPortal/components/AquariusCard";
import { SellingPlanConfigs } from "@smartrr/shared/entities/SellingPlanGroup";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { AddonList } from "../../../../AddonList";
import { IAddonListCard } from "../../types";
import { getDeliveryId } from "@customer-app/state/stores/delivery/DeliveryId";

export const AddonListCard = ({ delivery, purchasables }: IAddonListCard) => (
  <AquariusCard sx={{ height: "100%" }} className={prefixClassName("addon-container")}>
    <AddonList
      purchasables={purchasables}
      deliveryId={getDeliveryId(delivery)}
      title={typedLocalize("subscriptions.addToYourNextOrder.title")}
      configType={SellingPlanConfigs.ADDON}
    />
  </AquariusCard>
);
